import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type PositionsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function PositionsToolbar({
  canManage,
  onCreate,
}: PositionsToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ຕໍາແໜ່ງ</h2>
          <p className="text-muted-foreground">ຈັດການຕໍາແໜ່ງໃນອົງກອນ (ບໍ່ແມ່ນຄົນ).</p>
        </div>
        {canManage && (
          <div className="flex items-center space-x-2">
            <Button onClick={onCreate}>
              <PlusIcon className="h-4 w-4" />
              ສ້າງຕໍາແໜ່ງ
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
